import { render, staticRenderFns } from "./sendMessageDialog.vue?vue&type=template&id=381b651c&scoped=true"
import script from "./sendMessageDialog.vue?vue&type=script&lang=js"
export * from "./sendMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./sendMessageDialog.vue?vue&type=style&index=0&id=381b651c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b651c",
  null
  
)

export default component.exports